<div [formGroup]="form" class="grid-12 login-page__input">
    <label class="grid-6 grid-mobile-4" for="password"> {{ label }} : </label>
    <input type="password" class="grid-6 grid-mobile-4 textfield" id="newPassword" name="newPassword" formControlName="newPassword" />
    <div *ngIf="!newPassword.pristine" class="grid-6 push-6 grid-mobile-4 push-mobile-0 model-status--clear model-status--nopadding">
        <div *ngIf="newPassword.errors?.required && !newPassword.pristine" role="alert">
            <!-- ngMessage: required -->
            <div class="model-status--invalid">{{ 'global.field.error.required' | i18n }}</div>
            <!-- ngMessage: minlength -->
        </div>
        <div role="alert">
            <div *ngIf="newPasswordScore === 0" class="model-status--verylow">{{ 'global.password.status.verylow' | i18n }}</div>
            <div *ngIf="newPasswordScore === 1" class="model-status--low">{{ 'global.password.status.low' | i18n }}</div>
            <div *ngIf="newPasswordScore === 2" class="model-status--medium">{{ 'global.password.status.medium' | i18n }}</div>
            <div *ngIf="newPasswordScore === 3" class="model-status--valid">{{ 'global.password.status.strong' | i18n }}</div>
            <div *ngIf="newPasswordScore === 4" class="model-status--valid">{{ 'global.password.status.verystrong' | i18n }}</div>
        </div>
        <div>
            <ul class="password-meter">
                <!-- ngRepeat: i in getLength(length) track by $index -->
                <li
                    *ngFor="let i of [0, 1, 2, 3]"
                    class="password-meter__item"
                    [ngClass]="{
                        'password-meter__item--low': newPasswordScore === 1 && i < newPasswordScore,
                        'password-meter__item--medium': newPasswordScore === 2 && i < newPasswordScore,
                        'password-meter__item--strong': newPasswordScore >= 3 && i < newPasswordScore
                    }"
                ></li>
                <!-- end ngRepeat: i in getLength(length) track by $index -->
            </ul>
        </div>
    </div>
</div>
<div>
    <div *ngIf="!newPassword.valid && !newPassword.pristine" class="password-helper grid-6 push-6 grid-mobile-4 push-mobile-0">
        <div class="password-helperContent">
            <ul>
                <li *ngIf="newPassword.errors?.minlength || !newPassword.value">Doit avoir <span>12 caractères minimum</span></li>
                <li *ngIf="newPassword.errors?.validateAsOneUpper || !newPassword.value">Doit contenir <span>une majuscule</span></li>
                <li *ngIf="newPassword.errors?.validateAsOneLower || !newPassword.value">Doit contenir <span>une minuscule</span></li>
                <li *ngIf="newPassword.errors?.validateAsOneSpecial || !newPassword.value">Doit contenir <span>un chiffre ou symbole</span> (%,€,@ etc.)</li>
            </ul>
        </div>
    </div>
</div>
<div [formGroup]="form" class="grid-12 login-page__input">
    <label class="grid-6 grid-mobile-4" for="repeatPassword">{{ labelRepeat }} : </label>
    <input type="password" class="grid-6 grid-mobile-4 textfield" id="repeatPassword" name="repeatPassword" formControlName="repeatPassword" required />
    <div *ngIf="newPassword.value === repeatPassword.value && repeatPassword.value != '' && !repeatPassword.pristine" class="model-status model-status--valid model-status--clear grid-4 push-6 grid-mobile-4 push-mobile-0">OK</div>
    <div *ngIf="newPassword.value != repeatPassword.value && repeatPassword.value != ''" class="model-status model-status--clear grid-6 push-6 grid-mobile-4 push-mobile-0" role="alert">
        <div class="model-status--invalid">{{ 'global.field.error.compareTo' | i18n }}</div>
    </div>
</div>
